var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 485 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -433.62,
    y1: 415.91,
    x2: -433.62,
    y2: 414.91,
    gradientTransform: "matrix(0, 60, 485, 0, -201230, 26047)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58076b",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32007e",
    stopOpacity: 0
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rect-sm") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M485,30h0a30,30,0,0,1-30,30H30A30,30,0,0,1,0,30H0A30,30,0,0,1,30,0H455A30,30,0,0,1,485,30Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectSm);
export default __webpack_public_path__ + "static/media/rect-sm.55e8ec3478058d62a47442566eca1ec5.svg";
export { ForwardRef as ReactComponent };